import '@patsnap-ui/icon/assets/solid/chain.svg'
import { EMPTY_PLACEHOLDER } from '@patsnap/synapse_common_config'
import { getDicItemName, openPageWithoutPending } from '@patsnap/synapse_common_utils'
import { useLocale } from '@pharmsnap/shared/src/composition'
import { IDrugDetail, IGTableColumnsProps } from '@pharmsnap/shared/src/types'
import { getRedirectLinkStatic } from '@pharmsnap/shared/src/utils'
import { defineComponent, PropType } from '@vue/composition-api'
import {
  BDrugRnaDeliverySystem,
  BDrugRnaGeneticMaterial,
  BDrugRnaPairedRegion,
  BDrugRnaRegulationMechanism,
  BDrugRnaTargetTissues,
  BDrugRnaTechPlatform,
} from '.'
import { BMosaic, GIcon, GTable, GTooltip } from '../..'

export const BDrugRnaFieldTable = defineComponent({
  name: 'BDrugRnaFieldTable',
  props: {
    data: {
      type: Object as PropType<IDrugDetail>,
      required: true,
    },
  },
  setup() {
    const { locale } = useLocale()
    return {
      locale,
    }
  },
  render() {
    const columns: IGTableColumnsProps<IDrugDetail>[] = [
      {
        label: this.$tc('synapse_i18n.drug.rna.deliverySystem'),
        property: 'deliverySystem',
        minWidth: '160px',
        renderCell: (h, item) => {
          return (
            <BMosaic block={true} standardUserHasRights={false} trigger_point="DRUG_RNA">
              <BDrugRnaDeliverySystem data={item.row} locale={this.locale}></BDrugRnaDeliverySystem>
            </BMosaic>
          )
        },
      },
      {
        label: this.$tc('synapse_i18n.drug.rna.targetedTissues'),
        property: 'targetedTissues',
        minWidth: '160px',
        renderCell: (h, item) => {
          return (
            <BMosaic block={true} standardUserHasRights={false} trigger_point="DRUG_RNA">
              <BDrugRnaTargetTissues data={item.row} locale={this.locale} />
            </BMosaic>
          )
        },
      },
      {
        label: this.$tc('synapse_i18n.drug.rna.targetedRegion'),
        property: 'targetedRegion',
        minWidth: '160px',
        renderCell: (h, item) => {
          return (
            <BMosaic block={true} standardUserHasRights={false} trigger_point="DRUG_RNA">
              <BDrugRnaPairedRegion data={item.row} locale={this.locale}></BDrugRnaPairedRegion>
            </BMosaic>
          )
        },
      },
      {
        label: this.$tc('synapse_i18n.drug.rna.regulationMechanism'),
        property: 'regulationMechanism',
        minWidth: '160px',
        renderCell: (h, item) => {
          return (
            <BMosaic block={true} standardUserHasRights={false} trigger_point="DRUG_RNA">
              <BDrugRnaRegulationMechanism data={item.row} locale={this.locale}></BDrugRnaRegulationMechanism>
            </BMosaic>
          )
        },
      },
      {
        label: this.$tc('synapse_i18n.drug.rna.geneticMaterial'),
        property: 'geneticMaterial',
        minWidth: '160px',
        renderCell: (h, item) => {
          return (
            <BMosaic block={true} standardUserHasRights={false} trigger_point="DRUG_RNA">
              <BDrugRnaGeneticMaterial data={item.row} locale={this.locale}></BDrugRnaGeneticMaterial>
            </BMosaic>
          )
        },
      },
      {
        label: this.$tc('synapse_i18n.drug.rna.techPlatform'),
        property: 'techPlatform',
        minWidth: '160px',
        renderCell: (h, item) => {
          return (
            <BMosaic block={true} standardUserHasRights={false} trigger_point="DRUG_RNA">
              <BDrugRnaTechPlatform data={item.row} locale={this.locale}></BDrugRnaTechPlatform>
            </BMosaic>
          )
        },
      },
      {
        label: this.$tc('news.source'),
        property: 'source',
        minWidth: '160px',
        renderCell: (h, item) => {
          const { source_info_xna = [] } = item.row
          const displaySource = source_info_xna.filter((source) => source.source_url)
          return (
            <BMosaic block={true} standardUserHasRights={false} trigger_point="DRUG_RNA">
              {displaySource.length ? (
                <GTooltip theme="light" disabled={displaySource.length === 1}>
                  <GIcon
                    size={20}
                    svgName="SolidChain"
                    color="#1667B8"
                    class="cursor-pointer"
                    nativeOnClick={() => {
                      if (displaySource.length === 1) {
                        openPageWithoutPending(() => getRedirectLinkStatic(displaySource[0].source_url || '', this.locale))
                      }
                    }}
                  ></GIcon>
                  <template slot="content">
                    <div class="flex flex-col gap-y-1">
                      {displaySource.map((source) => (
                        <div
                          onClick={() => openPageWithoutPending(() => getRedirectLinkStatic(source.source_url || '', this.locale))}
                          class="text-sm leading-4 cursor-pointer hover:underline text-blue-default"
                        >
                          {getDicItemName(source.normalized_source_id_view, this.locale)}
                        </div>
                      ))}
                    </div>
                  </template>
                </GTooltip>
              ) : (
                EMPTY_PLACEHOLDER
              )}
            </BMosaic>
          )
        },
      },
    ]
    return <GTable data={[this.data]} columns={columns} border></GTable>
  },
})
